import { STOP_API_POLL, START_API_POLL, API_CALL } from '../constants/actionTypes';

const runningPolls = new Map();

function startPoll(dispatch, action, subscribers = 1) {
  // console.log('startPoll', action.getApiCall().api);
  const intervalId = setInterval(() => {
    // console.log('poll', action.getApiCall().api);
    dispatch({
      ...action.getApiCall(),
      type: API_CALL,
      timestamp: Date.now()
    });
  }, action.duration);
  runningPolls.set(action.key, {
    id: intervalId,
    subscribers,
    duration: action.duration
  });
}

export default function apiPollingMiddleware() {
  return ({ dispatch }) => next => action => {
    switch (action.type) {
      case START_API_POLL: {
        const existingPoll = runningPolls.get(action.key);
        if (existingPoll) {
          // keep track of how many things
          // request this poll run. That way we only
          // cancel it when everyone has stopped listening
          // handle if the duration has changed
          if (action.duration !== existingPoll.duration) {
            clearInterval(existingPoll.id);
            startPoll(dispatch, action, existingPoll.subscribers + 1);
          } else {
            existingPoll.subscribers += 1;
          }
        } else {
          // first time poll is running, start 'er up.
          startPoll(dispatch, action);
        }
        break;
      }
      case STOP_API_POLL: {
        const keys = action.keys || [action.key];
        // console.log('stopPoll', keys);
        keys.forEach(key => {
          const pollRef = runningPolls.get(key);
          if (pollRef) {
            pollRef.subscribers -= 1;
            if (pollRef.subscribers === 0) {
              runningPolls.delete(key);
              clearInterval(pollRef.id);
            }
          }
        });
        break;
      }
      default:
    }

    next(action);
  };
}
